<template>
    <v-card width="450">
        <v-card-title>
            <TitleOfDialog title="Export CSV" @close="emit('close')"></TitleOfDialog>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-form ref="formRef">
                <v-radio-group v-model="exportType" :rules="[v => !!v || 'You must select an export type']">
                    <v-radio color="primary" label="LOG" value="log" />
                    <v-radio color="primary" label="LIVE" value="live" />
                </v-radio-group>
                <v-text-field color="primary" label="File name" :rules="[v => !!v || 'File name is required']"
                    v-model="fileName"></v-text-field>
            </v-form>
            <v-progress-linear color="primary" :indeterminate="loading"></v-progress-linear>
        </v-card-text>
        <v-card-actions>
            <v-btn @click="exportCSV()" class="w-100" color="primary" variant="elevated" text="Export CSV"></v-btn>
        </v-card-actions>
    </v-card>
</template>


<script setup>
import TitleOfDialog from '@/components/base/TitleOfDialog.vue';
import { api_url } from '@/config/api_url';
import { useNotificationStore } from '@/store/notificationStore';
import axios from 'axios';
import { onMounted, ref, warn } from 'vue';

const loading = ref(false);
const exportType = ref();
const fileName = ref();
const formRef = ref();
const emit = defineEmits(['close']);
const props = defineProps({
    mission: Object,
    vehicle: Object
})

onMounted(() => {
    fileName.value = "export_mission_" + props.mission.name + "_vehicle_" + props.vehicle.name;
})

const notificationStore = useNotificationStore();

const exportCSV = async () => {

    const isValid = await formRef.value?.validate();
    if (!isValid.valid) return;


    try {
        loading.value = true;
        const response = await axios.get(`${api_url}/admin/mission/exportCSV/${props.mission.id}/${props.vehicle.id}/${exportType.value}/${fileName.value}`);
        if (response.data.fileUrl) {
            const fileUrl = api_url + "/" + response.data.fileUrl;
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = fileUrl.split('/').pop();
            link.click();
        } else {
        }
    } catch (error) {
        notificationStore.setNotification("Error", error.response.data.message, "mdi-alert", "error");
    } finally {
        loading.value = false;
        emit('close');
    }
}





</script>